/** Shared frontend limit for work period validation, UI and location tracking. */
export const MAX_WORK_PERIOD_DURATION_HOURS = 16
export const MAX_WORK_PERIOD_DURATION_MINUTES = MAX_WORK_PERIOD_DURATION_HOURS * 60
export const MAX_WORK_PERIOD_DURATION_MS = MAX_WORK_PERIOD_DURATION_MINUTES * 60 * 1000
